import { z } from "zod";

/**
 * Availability of one outreach channel on a resolved CC prospect (mirrors the
 * API's `CcChannelStatus`): `found` — usable value present, `missing` — absent
 * or invalidated, `enriching` — an enrichment lookup is currently running.
 */
export const CcChannelStatusSchema = z.enum(["found", "missing", "enriching"]);

export type CcChannelStatus = z.infer<typeof CcChannelStatusSchema>;

export const CcRecipientInfoSchema = z.object({
	email: z.string(),
	prospectId: z.number(),
	name: z.string().nullable(),
	overallScore: z.string().nullable(),
	linkedinStatus: CcChannelStatusSchema,
	emailStatus: CcChannelStatusSchema,
	phoneStatus: CcChannelStatusSchema,
});

export type CcRecipientInfo = z.infer<typeof CcRecipientInfoSchema>;

export const CcRecipientInfoListSchema = z.array(CcRecipientInfoSchema);
